import './facetComponent.scss';
import React from 'react';
import {HibuFacet} from './facetTypes';
import {DeepReadonly} from 'utility-types';
import {SvgIcon} from '../icons/svgIcon';
import {Icons} from '../icons/icons';
import {useLocalizationUtil} from '../localizationUtil';

type FacetComponentProps = {
    facet: DeepReadonly<HibuFacet>;
    onFacetToggled: () => void;
    onFacetMouseEnter: () => void;
    onFacetMouseLeave: () => void;
    multiSelect: boolean;
    selected: boolean;
    showCounts: boolean;
    focus?: boolean;
};

export const FacetComponent = React.memo((props: FacetComponentProps) => {
    const {formatNumber} = useLocalizationUtil();

    return (
        <div
            className={(props.focus ? 'facet-focused ' : '') + (props.selected ? 'facet-selected ' : '') + 'facet'}
            onMouseEnter={props.onFacetMouseEnter}
            onMouseLeave={props.onFacetMouseLeave}
            onClick={props.onFacetToggled}
        >
            <div className="facet-value" key={props.facet.value}>
                <span className="facet-value-text" dangerouslySetInnerHTML={{__html: `${props.facet.name}`}}></span>
                {props.showCounts && (
                    <span className="facet-count">
                        {formatNumber(props.facet.count)}
                    </span>
                )}
                {props.selected && <SvgIcon icon={Icons.X} className="facet-deselect-icon" />}
            </div>
        </div>
    );
});
